import { Outlet, useParams, } from "react-router-dom";
import { useEffect, useState } from "react";
import { exchangeOAuth, getPrevileges, login } from "../API/nimbleAPI";
import { setToken } from "../API/tokenStore";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { enqueueSnackbar } from "notistack";

const ProtectedRoute = () => {
    const [userDetails, setUserDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [reportConfiguration, setReportConfiguration] = useState(null);
    // const menuId = searchParams.get("menuID");
    // const menuId = "B0ED7B23D90D2AA84579D5FBE99AC03A0000";
    // const headerCorpId = "8CC96B15A082A2AC46F6FE0987E9D8F90000";
    // const Id = 15

    const { urlInfo, authId, menuId, corpId, showreport, rediskey } = useParams();

    useEffect(() => {
        getUserDetails();
    }, []);

    const getUserDetails = async () => {

        try {
            setLoading(true);

            // const authDetails = await login();
            // const authId = authDetails.authID

            const token = await exchangeOAuth(authId);
            setToken(token);
            const previleges = await getPrevileges(menuId);
            setUserDetails({ authId, headerCorpId: corpId, menuId, urlInfo ,previleges });

        } catch (error) {
            setError(error);
            setUserDetails(null);
            enqueueSnackbar(error.message || "Authentication failed", {
                variant: "error",
            });

        } finally {
            setLoading(false);
        }
    };

    if (error) {
        throw error;
    }
    if (loading || !userDetails) {
        return (
            <Backdrop open>
                <CircularProgress />
            </Backdrop>
        );
    };

    return <Outlet
        context={{
            ...userDetails,
            showreport,
            rediskey,
            reportConfiguration,
            setReportConfiguration,
        }}
    />;

};

export default ProtectedRoute;
